<template>
  <div>
    <b-card style="border: none;">
      <b-row>
        <b-col>
          <label for="description">Beschreibung</label>
          <b-row>
            <b-col>
          <b-form-textarea
              id="description"
              class="text-black"
              placeholder="Beschreiben Sie Ihren Auftrag."
              rows="8"
              max-rows="8"
              wrap="hard"
              v-model="description"
          >
          </b-form-textarea>
              <mic-icon title="" v-tooltip="'Nachricht aufnehmen'" @click="openMic" class="icon-2x" fillColor="#2463ea"
                          style="cursor: pointer; color: #2463ea;
                          position: absolute;
    bottom: 8px;
    right: 24px;" :size="72" ></mic-icon>

            </b-col>
          </b-row>
          <label for="title" class="mt-2">Stammauftrag</label>
          <b-form-input id="title" ref="stamm_input" type="text" style="color: black!important;"
                        v-model="current_gi_match"
                        placeholder="Stammauftrag auswählen."
                        class="mb-2"
                        @click.stop="$refs.stamm_input.blur();showTaskDialog=true"
                        @focusin.stop="$refs.stamm_input.blur();showTaskDialog=true"
          ></b-form-input>
          <b-row class="mt-3">
            <b-col>
              <b-form-input type="text"
                            style="white-space: nowrap; text-overflow: ellipsis"
                            :placeholder="latLonText"
                            class="mb-2 elips"
                            :disabled="true"
                            v-model="latLonText"
              ></b-form-input>
            </b-col>
            <b-col>
              <b-button variant="success" class="btn-pill font-lg" @click="openGps">
                Koordinaten setzen
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="message_files !== null && message_files.length">
            <b-col>
              <span>Anhänge aus dem Chat: </span>
                <a style="margin-left: 15px"
                   v-for="item in (message_files === null ? [] : message_files)"
                   v-if="item !== ''"
                   target="_blank"
                   v-on:click.prevent="">
                  {{item.split('/')[item.split('/').length -1]}};
                </a>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="12">
              <span>Anhänge</span>
              <vue-dropzone ref="drop" id="drop" :options="dropOptions" style="max-height: 25vh; overflow: auto; padding: 8px"></vue-dropzone>
            </b-col>
          </b-row>
          <label for="date" v-if="canAccept" class="mt-3">Zieldatum</label>
          <datetime
              v-if="canAccept"
              v-model="due"
              input-class="form-control mb-2"
              input-style="color: black;"
              input-id="date"
              :phrases="datetimeConfig.phrases"
              :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
              :min-datetime="datetimeConfig.minTime"></datetime>
          <b-row class="mt-3"  v-if="canAccept">
            <b-col class="my-auto">
              <span>Mitarbeiter zuweisen:</span>
            </b-col>

            <b-col >
              <b-row style="flex-direction: row-reverse; margin-right: 8px">
                <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
                <plus-icon title="" v-tooltip="'Hinzufügen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.select_plannings.showDialog(users)"></plus-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-table striped hover selectable :items="selectedPlannings" :fields="planningFields"
                   select-mode="single"
                   v-if="canAccept"
                   class="mt-2"
                   selectedVariant="primary"
                   ref="group_table"
                   @row-selected="onRowSelected"
          >
            <template v-slot:cell(memo)="data">
              <div style="display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;">{{data.item.memo}}</div>
            </template>
          </b-table>
          <b-row class="mt-5" style="flex-direction: row-reverse">
              <b-button variant="success" class="btn-pill font-lg" style="margin-right: 18px"
              :disabled="!canSend" @click="onSend">
                Absenden
              </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <select-planning-dialog ref="select_plannings" @planning-selected="onNewPlanning"></select-planning-dialog>
    <b-modal size="md" v-model="showTaskDialog" centered title="Stammauftrag auswählen"
    >
      <b-row >
        <b-col style="height: 55vh; overflow: auto">
          <b-table striped hover selectable :items="groups" :fields="group_fields"
                   select-mode="single"
                   selectedVariant="primary"
                   @row-selected="rowSelectedGroup"
                   ref="group_table"
          >
          </b-table>
        </b-col>
        <b-col style="height: 55vh; overflow: auto">
          <b-table striped hover :items="objects" :fields="object_fields" selectable
                   select-mode="single"
                   selectedVariant="primary"
                   @row-selected="rowSelectedObject"
                   ref="object_table"
          >
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="showTaskDialog = false">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!canContinueTask" variant="success" @click="showTaskDialog = false">
          Speichern
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import vueDropzone from "vue2-dropzone";
import MicIcon from 'vue-material-design-icons/MicrophoneOutline.vue'
import PlusIcon from 'vue-material-design-icons/PlusCircle.vue';
import MinusIcon from 'vue-material-design-icons/MinusCircle.vue';
import SelectPlanningDialog from "../../aufgaben_verwaltung/SelectPlanningDialog.vue"
import {decryptArray, encryptAES, encryptFile, encryptTodos} from "@/shared/crypto";
import {v4} from "uuid";

export default {
  name: "AndroidCreateShort",
  components: {
    vueDropzone,
    MicIcon,
    PlusIcon,
    MinusIcon,
    SelectPlanningDialog,
  },
  props: {
    canAccept: Boolean,
  },
  data() {
    return {
      loader: undefined,
      due: null,
      description: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      taskTitle: "",
      lat: 0.0,
      lon: 0.0,
      latLonText: "Keine Koordinaten gesetzt.",
      messages: [],
      roomId: null,
      message_files: [],
      dropOptions: {
        url: "https://httpbin.org/post",
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='icon-cloud-upload icon font-4xl mr-3 mt-3'></i>",
        dictRemoveFile: "Entfernen",
        maxFilesize: 5,
        dictFileTooBig: "Die Datei ist zu groß ({{filesize}}MB). Maximale Dateigröße: {{maxFilesize}}MB",
      },
      users: [],
      currentPlanning: null,
      selectedPlannings: [],
      planningFields: [{key: "name", label: 'Name'}],
      // tasks
      showTaskDialog: false,
      currentGroup: {},
      groups: [],
      objects: undefined,
      objectsMap: {},
      group_fields: [{key: "titel", label: 'Gruppe wählen'}],
      object_fields: [{key: "gi_match", label: 'Objekt wählen'}],
      selectedTask: [],
      current_gi_match: "",

      files: [],
    }
  },
  computed: {
    latLon() {
      if (this.lat === 0.0 || this.lon === 0.0) {
        return "Keine Koordinaten gesetzt.";
      }
      return ""+this.lat + ", " + this.lon;
    },
    canContinueTask() {
      return this.selectedTask.length > 0;
    },
    canSend() {
      return this.description !== "" && this.selectedTask.length > 0;
    }
  },
  watch: {
    due(n, o) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (!this.selectedPlannings[i].dueDate) {
          this.selectedPlannings[i].dueDate = n;
        }
      }
    }
  },
  beforeMount(){
    window['AndroidWebView'] = {
      components:  this,
      onSetDescription: (msg) =>  this.onSetDescription(msg),
      onSetLatLon: (lat, lon) => this.onSetLatLon(lat, lon),
    };
  },
  created() {
    if (this.$route.query.message_payload !== undefined) {
      let messagePayloadId = this.$route.query.message_payload;
      let payload = JSON.parse(sessionStorage.getItem(messagePayloadId));
      this.roomId = payload.roomId;
      this.messages = payload.messages;
    }
    this.showLoader();
    let data = {};
    if (this.roomId) {
      data.room_id = this.roomId;
      data.messages = this.messages;
    }
    this.$http.get(
        Server_URL+'/auftragsbuch/data/create/step_android', {params: data}
    ).then(this.responseOkFetch, this.responseError)
  },
  methods: {
    openMic() {
      Android.openMic();
    },
    openGps() {
      Android.openGps();
    },
    onSetDescription(desc) {
      this.description = desc;
    },
    onSetLatLon(lat, lon) {
      this.lat = lat;
      this.lon = lon;
      this.latLonText = this.latLon
    },
    onSend() {
      if ((!this.due || this.due === "") && this.selectedPlannings.length > 0) {
        this.$bvToast.toast("Bitte wählen Sie ein Zieldatum aus, wenn Sie diese Aufgabe beplanen möchten.", {
          title: 'Achtung',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
        })
      }
      this.files = this.$refs.drop.getQueuedFiles();
      let coords = {lat: 0.0, lon: 0.0};
      if (this.lat !== 0.0) {
        coords.lat = this.lat;
        coords.lon = this.lon;
      }
      let data = {
        gi_match: this.current_gi_match,
        gi_memo: this.description,
        ziel_datum: this.due === "" ? null : this.due,
        gi_auf_ext: this.current_gi_match,
        dringlich: "stufe1",
        aufgabe: "0",
        group_name: this.$cookies.get("ps_user_id"),
        group_id: -1,
        gi_memo_plain: this.description,
        coords: coords,
        gi_augr: this.currentGroup.key,
        gi_aufisn: this.selectedTask[0].gi_aufisn,
      };
      if (this.files.length !== 0 ||
          (this.message_files && this.message_files.length)) {
        data.has_files = true;
      }
      if(this.canAccept) {
        data.accept_task = 'Aufgabe';
        data.todos = this.selectedPlannings;
      }
      this.showLoader();
      encryptAES(sessionStorage.getItem("aes"), data.gi_memo).then(res => {
        data.gi_memo = res;
        if (data.todos && data.todos.length) {
          data.key = sessionStorage.getItem("aes");
          encryptTodos(sessionStorage.getItem("aes"), data.todos).then(res => {
            data.todos = res;
            this.startUpload(data)
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.startUpload(data);
        }
      }).catch(res => {
        console.log(res);
      })
    },
    startUpload(payload) {
      let additionData = {};
      if (this.$route.query.message_payload !== undefined) {
        let messagePayloadId = this.$route.query.message_payload;
        let payload = JSON.parse(sessionStorage.getItem(messagePayloadId));
        sessionStorage.removeItem(messagePayloadId);
        additionData.room_id = payload.roomId;
        additionData.messages = payload.messages;
      }

      this.$http.post(
          Server_URL+'/auftragsbuch/data/create?short=true',
          payload, {params: additionData}
      ).then(this.responseOk, this.responseError)
    },
    responseOk(response) {
      if (this.files.length === 0) {
        this.hideLoader();
      }
      if (response.status === 200 && response.body.status === "ok") {
        this.data_id = response.body.data.id;
        if (this.files.length === 0) {
          Android.onUploadOk();
        } else {
          this.uploadFile();
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseUploadOk(response) {
      if (this.files.length === 0) {
        this.hideLoader();
      }
      if (response.status === 200 && response.body.status === "ok") {
        if (this.files.length === 0) {
          if (navigator.userAgent.startsWith("Windows - BisOffice")) {
            this.$router.go(-1);
            return;
          }
          Android.onUploadOk();
        } else {
          this.uploadFile();
        }
      } else {
        window.location = Redirect_500;
      }
    },
    uploadFile() {
      if (this.files.length !== 0) {
        let file = this.files.pop();
        if (sessionStorage.getItem("aes") !== null) {
          const reader = new FileReader();
          reader.addEventListener('load', (event) => {
            let buf = new Uint8Array(event.target.result);
            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
              const b = new Blob([res], {type: file.type});
              let formData = new FormData();
              formData.append('upload_file', b, file.name);
              formData.append('key', sessionStorage.getItem("aes"))
              this.$http.post(Server_URL + '/auftragsbuch/upload/file/'
                  + this.data_id + "?file_type=A",
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
              ).then(this.responseUploadOk, this.responseError)
            }).catch(err => {
              console.log(err);
              this.hideLoader();
            })
          });
          reader.readAsArrayBuffer(file);
        } else {
          let formData = new FormData();
          formData.append('upload_file', file);
          this.$http.post(Server_URL + '/auftragsbuch/upload/file/'
              + this.data_id + "?file_type=A",
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          ).then(this.responseUploadOk, this.responseError)
        }
      }
    },
    rowSelectedGroup(items) {
      if (items.length === 0) {
        this.objects = undefined;
        this.selectedTask = [];
        this.currentGroup = {};
      } else {
        this.objects = this.objectsMap[items[0].key];
        this.currentGroup = items[0];
        if (this.objects.length === 1) {
          this.$nextTick(() => {
            this.$refs.object_table.selectRow(0);
          });
        }
      }
    },
    rowSelectedObject(items) {
      this.selectedTask = items;
      if (items.length === 0) {
        this.current_gi_match = "";
      } else {
        this.current_gi_match =  items[0].gi_match;
      }
    },
    responseOkFetch(response) {
      if (response.status === 200 && response.body.status === "ok") {
        if (this.canAccept) {
          this.users = response.body.data.bhStructure;
          this.computeMitas(this.users);
        }
        this.messages = response.body.data.messages;
        this.message_files = response.body.data.files;
        for (let i = response.body.data.augrs.length-1; i >= 0; i--) {
          if (response.body.data.augrToAufisn[response.body.data.augrs[i].key] === undefined) {
            response.body.data.augrs.splice(i, 1)
          }
        }
        this.groups = response.body.data.augrs;
        this.objectsMap = response.body.data.augrToAufisn;

        if (this.messages && this.messages.length) {
          decryptArray(sessionStorage.getItem("aes"), this.messages).then(res => {
            this.messages = res;
            let desc = "";
            for (let i = 0; i < this.messages.length; i++) {
              desc += this.messages[i] + "\n";
            }
            this.description = desc;
          }).catch(res => {
            console.log(res)
          })
        }
        this.hideLoader();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    onNewPlanning(selected) {
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        cur.memo = this.description;
        cur.dueDate = this.due;
        this.selectedPlannings.push(cur);
      }
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === this.currentPlanning._id) {
          this.selectedPlannings.splice(i, 1);
        }
      }
      this.currentPlanning = null;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
  }
}
</script>

<style scoped>

</style>
